exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.staff-group{padding-left:1em;padding-top:1em\n}\n.staff-group .basic-user-card{padding-left:0\n}", ""]);

// exports
